import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { SettingsProvider } from "@/lib/settings";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Plants from "@/pages/Plants";
import PlantDetail from "@/pages/PlantDetail";
import Identify from "@/pages/Identify";
import Tours from "@/pages/Tours";
import TourDetail from "@/pages/TourDetail";
import CalendarPage from "@/pages/CalendarPage";
import Community from "@/pages/Community";
import Coach from "@/pages/Coach";
import Journal from "@/pages/Journal";
import Favorites from "@/pages/Favorites";
import Quiz from "@/pages/Quiz";
import Recipes from "@/pages/Recipes";
import Blog from "@/pages/Blog";
import ArticleDetail from "@/pages/ArticleDetail";
import Compare from "@/pages/Compare";
import Contact from "@/pages/Contact";
import Impressum from "@/pages/Impressum";
import Downloads from "@/pages/Downloads";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import { AdminResetPage } from "@/components/admin/AdminLogin";
import EmbedPlants from "@/pages/EmbedPlants";
import EmbedTours from "@/pages/EmbedTours";
import CmsPage from "@/pages/CmsPage";
import EventCheckin from "@/pages/EventCheckin";
import Partner from "@/pages/Partner";

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/plants" element={<Plants />} />
            <Route path="/plants/:slug" element={<PlantDetail />} />
            <Route path="/identify" element={<Identify />} />
            <Route path="/tours" element={<Tours />} />
            <Route path="/tours/:slug" element={<TourDetail />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/community" element={<Community />} />
            <Route path="/coach" element={<Coach />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/recipes" element={<Recipes />} />
            <Route path="/magazin" element={<Blog />} />
            <Route path="/magazin/:slug" element={<ArticleDetail />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/reset" element={<AdminResetPage />} />
            <Route path="/embed/plants" element={<EmbedPlants />} />
            <Route path="/embed/tours" element={<EmbedTours />} />
            <Route path="/embed/booking" element={<EmbedTours />} />
            <Route path="/p/:slug" element={<CmsPage />} />
            <Route path="/event-checkin/:tourId" element={<EventCheckin />} />
            <Route path="/partner" element={<Partner />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
